<script setup>
import { ref } from 'vue'
import OutlineButton from '../buttons/OutlineButton.vue'
const props = defineProps({
    upperTitle: {
        type: String,
        default: 'Orion by fusion'
    },
    title: {
        type: String,
        default: 'Un agent IA dédié aux commissaires de justice'
    },
})


</script>

<template>
    <section class="hero-banner">
        <div class="hero-content">
            <p class="hero-upper-title">{{ upperTitle }}</p>
            <h1 class="hero-title">{{ title }}</h1>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.hero-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    flex-direction: column;
    gap: 8px;  
    padding: 125px 0 50px;
    position: relative;

    &:before{
        content: "";
        position: absolute;
        width: 95vw;
        aspect-ratio: 16 / 4;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
        background-image: url(/images/legal-page-stars.webp);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        z-index: -2;
    }

    &:after{
        content: "";
        position: absolute;
        width: 45vw;
        aspect-ratio: 78 / 66;
        bottom: 0;
        left: 50%;
        transform: translate(-75%, -25%);
        border-radius: 791px;
        opacity: 0.3;
        background: rgba(48, 162, 255, 0.70);
        filter: blur(150px);
        z-index: -1;
    }

    & .hero-content {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 15px;
        width: 100%;
        max-width: 650px;

        & .hero-upper-title {
            text-align: center;
            font-family: $tertiary-font-family;
            font-size: 2em;
            line-height: $upper-title-line-height;
            background: $title-background-gradient--blue;
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 0;
        }

    
        & .hero-btn {
            margin-top: 20px;
        }
    }
}

// Responsive
@media (min-width: 767px) {
    .hero-banner {

    
        min-height: 50vh;
        flex-direction: row;
        gap: 50px;  
        padding-top: 125px;

        & .hero-upper-title{
            font-size: 28px;
        }

        & .hero-videos:before, 
        & .hero-videos::after{
            width: 175px;
        }
        & .hero-videos{
            &::before {
                top: -35px;
                left: -35px;
            }

            &::after {
                bottom: -35px;
                right: -35px;
            }
        }
    }
}

</style>